export default "__VITE_ASSET__BVJ1hAGH__"